<!-- START: TV frame -->
<div class="tv-set">
  <div class="tv-border">
    <div class="tv-screen">
      <ng-content></ng-content>
    </div>
    <span class="tv-led"></span>
  </div>
  <div class="tv-stand"></div>
</div>
<!-- END: TV frame -->
